var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKakao(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23,
    fill: "url(#pattern0_20_3218)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_20_3218",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_20_3218",
    transform: "matrix(0.0281863 0 0 0.0294118 -0.00735294 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_20_3218",
    width: 36,
    height: 34,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAiCAYAAAA3WXuFAAAByUlEQVRYCc2XTSsFURjHfwmlFJJvYMlKVkjZeFmzUVLKwsLSHl9Ayk4pSWLBxh4lKR8AZeF1ZSMkylv/aY5mbjNz78wZd85TtzP33PP8n989c85zngPprA0YB1aAQ+AaeAd+/I+e1XcALPtj5ZOr1QETwBHwFQhuIMq18pGvNOptyGqAKeA2A0QcpLSkKe1U1g6c5ghSCihtxajIhoHnf4QxcIqhWIk2CnxWAcZAKdZYHFEv8FFFGAOlmIodsibgvgAYA/UAiOHPlgqEMVBi8EyJ680BIDF4SXTWARgzS2Jh3yEgsXDnEJA2VuhwNFNXVKvDuZDcE/eHtbC5ceiVqXRh2yGgXQFNOwSk0oRG4MkBKDE0C0i26ADQgs/iNQ3ARYFQl4AYQtZZ0Kt7ATpCJIEvfVWqFk0eegX6A/EjH7urlJtUA3VFEkR0tgI7/7imlG8y3dcmc4Y6A4YiJqDirpkcgJRfNoCBiqMmDNwrA/QInPsljNbEFXAMbAJzgDZJbYJ+qp8klJTB14GWVIqWg3tiZkdF1Iildib3+QigteB5k0nVwukkAKQy12p3WHB4rrq06Zr7DayWXuJsxbP4qyTZAgazONv4/AI4FjZGdhqZJAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakao);
export default __webpack_public_path__ + "static/media/kakao.1dd023981208f58e418a5a692c0c0cb5.svg";
export { ForwardRef as ReactComponent };